import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalDeleteAccountEN extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Delete account';
		const siteDescription =
			"When you delete your account, all your data will be permanently removed. For security reasons, we can't delete an account for you. You’ll need to be able to log into your account to request deletion.";
		const siteKeywords = 'Delete account keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/deleteaccount/en';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<img src={require('../../../containers/Html/icons/symbol1.svg')} alt="glossiq icon" />
						<InfoPageHeaderTitle>Delete Your Account</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<hr />
					<InfoPageSection>
						<p>
							When you delete your account, all your data will be permanently removed. For security reasons, we can't
							delete an account for you. You’ll need to be able to log into your account to request deletion.
						</p>

						<InfoPageTitle1>To request the permanent deletion of your account: </InfoPageTitle1>

						<ul>
							<li>
								Log in to your account: Visit Glossiq.com using your computer or open the mobile application and sign in
								using your account credentials.
							</li>

							<li>
								Locate the account settings: On a computer, click on your profile picture at the top right corner of the
								screen and then click on <Link to="/account">Settings</Link>. On the mobile app, click on Profile at the
								button right corner and then click on Account.
							</li>

							<li>
								Access the account deletion option: Scroll down to Deactivate account section and click on the button
								'Deactivate my account'.
							</li>

							<li>
								Confirm your intention to delete: If you are certain about deleting your account, click on the button
								'Next'.
							</li>

							<li>
								Provide feedback: give your reason for leaving or select 'Other' if you don't want to share and then
								click on 'Deactivate my account' to initiate the deletion process.
							</li>

							<li>Check your email: You will receive a confirmation message that confirms your account deletion.</li>
						</ul>

						<p>
							After 7 days of your account deletion request, your account and all your information will be permanently
							deleted, and you won't be able to retrieve your information.
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalDeleteAccountEN };
